import React, { Component } from 'react';
import { injectIntl, defineMessages, FormattedMessage  } from 'react-intl';
import PropTypes from 'prop-types';
import { getPeriodDescription, compareStrings } from '../utils/utils';
import ReportName from './ReportName';
import { Table, Space, Popconfirm } from 'antd';
import {REPORT_PERIOD_EVENT} from '../utils/constants';

const messages = defineMessages({
    DeleteConfirm: {
      id: 'DeleteConfirm',
    },  
});

class EmailReportsTable extends Component {
    constructor(props) {
        super(props);

        this.columns = [
            {
              title: <FormattedMessage id="Email"/>,
              dataIndex: 'email',
              
              sorter: {
                compare: (a, b) => compareStrings(a.email, b.email)
              },
            },
            {
              title: <FormattedMessage id="Report"/>,
              
              render: (_, record) =>
                <div>
                <ReportName report_url={record.url}/>
                </div>,
              sorter: {
                compare: (a, b) => compareStrings(a.url, b.url)
              },
            },
            {
              title: <FormattedMessage id="Period"/>,
              
              render: (_, record) =>
                <div>
                <FormattedMessage id={getPeriodDescription(record.period)}/>
                </div>,
              sorter: {
                compare: (a, b) => a.period - b.period,
              },
            },
            {
              title: <FormattedMessage id="Action"/>,
              key: 'action',
              render: (_, record) =>
                    <Space size="middle">
                        <a href="#!"onClick={() => this.handleEdit(record.id)}><FormattedMessage id="Edit"/></a>
                        <Popconfirm title={this.props.intl.formatMessage(messages.DeleteConfirm)} onConfirm={() => this.handleDelete(record.id)}>
                        <a href="#!"><FormattedMessage id="Delete"/></a>
                        </Popconfirm>
                        {record.period !== REPORT_PERIOD_EVENT && <a href="#!"onClick={() => this.handleSendNow(record.id)}><FormattedMessage id="Send"/></a>}
                    </Space>
            },
        ];   
      }

    handleDelete(id)
    {
      this.props.onDelete(id);
    }

    handleEdit(id)
    {
        this.props.onEdit(id);
    }

    handleSendNow(id)
    {
        this.props.onSendNow(id);
    }

     render() {
    
          return (
            <div><Table bordered showSizeChanger={false} pagination={false} rowKey={record => record.id} columns={this.columns} dataSource={this.props.data} /></div>
          );
        }
    } 
       
    EmailReportsTable.propTypes = {
    data: PropTypes.array.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onSendNow: PropTypes.func.isRequired
    };

export default injectIntl(EmailReportsTable, {
    withRef: true,
  });
